import type { ChatMessage, MCPServer } from "@/types";

export const MOCK_SERVERS: MCPServer[] = [
  // is this production or development?
  process.env.NODE_ENV === "production"
    ? {
        id: "hapi-petstore-6b39032c2706",
        name: "Petstore",
        url: "https://petstore.run.mcp.com.ai/mcp",
        transport: "http",
        status: "online",
        role: "An assistant to help people adopt the best pet based on their lifestyle and personality.",
        headers: {}
      }
    : {
        id: "petstore-local",
        name: "Petstore LOCAL",
        url: "http://localhost:3001/mcp",
        transport: "http",
        status: "online",
        role: "An assistant to help people adopt the best pet based on their lifestyle and personality.",
        headers: {}
      },
  // {
  //   id: "quetzalcoatl",
  //   name: "Ketzal",
  //   url: "/mock/mcp",
  //   role: "Aztec god of wind, wisdom, and creation. Guides with knowledge and insight.",
  //   transport: "mock",
  //   status: "online",
  //   color: "from-green-600 via-lime-400 to-yellow-300",
  // },
  // {
  //   id: "huitzilopochtli",
  //   name: "Weetzee",
  //   url: "/mock/mcp",
  //   role: "Aztec god of sun and war. Strategist and protector in challenging situations.",
  //   transport: "mock",
  //   status: "online",
  //   color: "from-yellow-600 via-orange-500 to-red-600",
  // },
  // {
  //   id: "itzcuintli",
  //   name: "Itzy",
  //   url: "/mock/mcp",
  //   role: "Loyal Aztec warrior and guide, inspired by the Xoloitzcuintli dog, guardian of the underworld.",
  //   transport: "mock",
  //   status: "connecting",
  //   color: "from-gray-700 via-blue-900 to-indigo-400",
  // }
];

const nowIso = () => new Date().toISOString();

export const MOCK_THREADS: Record<string, ChatMessage[]> = {
  "hapi-petstore-6b39032c2706": [
    {
      id: "hapi-petstore-1",
      author: "user",
      contactId: "hapi-petstore-6b39032c2706",
      content: "I want to adopt a pet. Can you help me?",
      createdAt: nowIso(),
      status: "sent",
    },
    {
      id: "hapi-petstore-2",
      author: "agent",
      contactId: "hapi-petstore-6b39032c2706",
      content: "Sure! I can help you find the perfect pet. What kind of pets are you interested in?",
      createdAt: nowIso(),
      status: "sent",
    },
  ],
  // quetzalcoatl: [
  //   {
  //     id: "quetzalcoatl-1",
  //     author: "agent",
  //     contactId: "quetzalcoatl",
  //     content: "Hey! I'm Ketzal. Drop a prompt and I'll route it to the right MCP tools.",
  //     createdAt: nowIso(),
  //     status: "sent",
  //   },
  // ],
  // huitzilopochtli: [
  //   {
  //     id: "huitzilopochtli-1",
  //     author: "agent",
  //     contactId: "huitzilopochtli",
  //     content: "Standing by to triage incidents or ship config changes.",
  //     createdAt: nowIso(),
  //     status: "sent",
  //   },
  // ],
  // itzcuintli: [
  //   {
  //     id: "itzcuintli-1",
  //     author: "agent",
  //     contactId: "itzcuintli",
  //     content: "Connecting to the MCP host... I'll let you know once the stream is live.",
  //     createdAt: nowIso(),
  //     status: "streaming",
  //   },
  // ],
};
